import React, { useState } from "react";
import { usePublicLang } from "../../../config/i18n/public";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const { copy } = usePublicLang();
  const c = copy.faq;
  const items = c.items;

  return (
    <section className="w-full min-h-screen bg-[#f3f7fd] flex flex-col">
      <div className="mx-auto flex w-full max-w-[1480px] flex-1 flex-col px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-[#222] mb-10">
          {c.title}
        </h2>

        {/* FAQ items */}
        <div className="flex-1 flex flex-col justify-evenly divide-y divide-[#cfd8e3]">
          {items.map((item, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className="select-none">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="w-full py-10 sm:py-12 text-left"
                  aria-expanded={open}
                  aria-controls={`faq-panel-${i}`}
                >
                  <div className="grid grid-cols-[1fr_auto] items-center gap-6">
                    <p className="text-2xl sm:text-3xl font-semibold text-[#1f2937]">
                      {item.q}
                    </p>
                    <span
                      className="h-10 w-10 grid place-items-center text-[#111]"
                      aria-hidden
                    >
                      {open ? <MinusIcon /> : <PlusIcon />}
                    </span>
                  </div>
                </button>

                {/* Answer panel */}
                <div
                  id={`faq-panel-${i}`}
                  className={`overflow-hidden transition-[grid-template-rows] duration-300 ease-out ${
                    open ? "grid grid-rows-[1fr]" : "grid grid-rows-[0fr]"
                  }`}
                >
                  <div className="min-h-0">
                    <p className="pb-10 sm:pb-12 pr-12 text-xl leading-8 text-[#4b5563]">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* Icons */
function PlusIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="28"
      height="28"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}
function MinusIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="28"
      height="28"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
    >
      <path d="M5 12h14" />
    </svg>
  );
}
